import { render, staticRenderFns } from "./HeaderNewCamp.vue?vue&type=template&id=2d181a07&scoped=true&"
import script from "./HeaderNewCamp.vue?vue&type=script&lang=js&"
export * from "./HeaderNewCamp.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNewCamp.vue?vue&type=style&index=0&id=2d181a07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d181a07",
  null
  
)

export default component.exports